var _process$env$STORYBOO, _process$env$STORYBOO2, _process$env$STORYBOO3, _process$env$STORYBOO4, _process$env$STORYBOO5, _process$env$STORYBOO6, _process$env$STORYBOO7, _process$env$STORYBOO8, _process$env$STORYBOO9, _process$env$STORYBOO10, _process$env$STORYBOO11;
// Cspell: disable

export const defaultConfig = {
  accounts: {
    authCallbackUrl: (_process$env$STORYBOO = process.env.STORYBOOK_AUTH_CALLBACK_URL) !== null && _process$env$STORYBOO !== void 0 ? _process$env$STORYBOO : "",
    host: (_process$env$STORYBOO2 = process.env.STORYBOOK_SCMP_ACCOUNT_HOST) !== null && _process$env$STORYBOO2 !== void 0 ? _process$env$STORYBOO2 : "",
    registerCallbackUrl: (_process$env$STORYBOO3 = process.env.STORYBOOK_REGISTER_CALLBACK_URL) !== null && _process$env$STORYBOO3 !== void 0 ? _process$env$STORYBOO3 : ""
  },
  corporateSubscriber: {
    host: (_process$env$STORYBOO4 = process.env.STORYBOOK_CORPORATE_SUBSCRIBER_HOST) !== null && _process$env$STORYBOO4 !== void 0 ? _process$env$STORYBOO4 : ""
  },
  environment: "dev",
  facebook: {
    appId: "282931841805811",
    likeUrl: (_process$env$STORYBOO5 = process.env.STORYBOOK_FACEBOOK_LIKE_URL) !== null && _process$env$STORYBOO5 !== void 0 ? _process$env$STORYBOO5 : ""
  },
  graphql: {
    apiKey: (_process$env$STORYBOO6 = process.env.STORYBOOK_CONTENTSERVICE_APIKEY) !== null && _process$env$STORYBOO6 !== void 0 ? _process$env$STORYBOO6 : "",
    host: (_process$env$STORYBOO7 = process.env.STORYBOOK_CONTENTSERVICE_HOST) !== null && _process$env$STORYBOO7 !== void 0 ? _process$env$STORYBOO7 : ""
  },
  mixpanel: {
    token: (_process$env$STORYBOO8 = process.env.STORYBOOK_MIXPANEL_TOKEN) !== null && _process$env$STORYBOO8 !== void 0 ? _process$env$STORYBOO8 : ""
  },
  newsletter: {
    globalImpact: "506194",
    lunar: "501957",
    postMag: "322743",
    thisWeekInAsia: "323063"
  },
  notification: {
    // No need to take from environment since it's being mocked
    host: ""
  },
  readingHistory: {
    // No need to take from environment since it's being mocked
    apiKey: "",
    host: "/reading-history"
  },
  recaptcha: {
    siteKey: (_process$env$STORYBOO9 = process.env.STORYBOOK_RECAPTCHA_SITE_KEY) !== null && _process$env$STORYBOO9 !== void 0 ? _process$env$STORYBOO9 : ""
  },
  siteUrl: (_process$env$STORYBOO10 = process.env.STORYBOOK_SITE_URL) !== null && _process$env$STORYBOO10 !== void 0 ? _process$env$STORYBOO10 : "",
  subscribe: {
    host: (_process$env$STORYBOO11 = process.env.STORYBOOK_ROSETTA_HOST) !== null && _process$env$STORYBOO11 !== void 0 ? _process$env$STORYBOO11 : ""
  },
  twitter: {
    accountName: "SCMPnews"
  }
};